import { TbTruckDelivery } from 'react-icons/tb'

import { dictionaryCodeFormTemplate } from '../Components/DictionaryCodeHint'
import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { STATUS_LIST_COLUMNS, STATUS_LIST_FILTERS, statusListFields } from '../Contracts/StatusListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Статуси перевізників» (сім'я `StatusList`, `SPEC-007` §4).
 *
 * Стан картки перевізника: системні коди `carrier-*` веде верифікація (`SPEC-010`).
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListCarrierStatusResource: IResourceConfig = {
    title: 'Статуси перевізників',
    fields: statusListFields(),
    table: {
        showColumns: STATUS_LIST_COLUMNS,
    },
    filter: {
        includeFields: STATUS_LIST_FILTERS,
    },
    // Підказка про код — у формі, над полем «Код» (`SPEC-007` §12)
    form: {
        template: dictionaryCodeFormTemplate,
    },
    places: {
        top: <TopMenu current="carrier-statuses" />,
    },
    restUrl: '/services/carrier_statuses',
    pageUrl: '/settings/carrier-statuses',
    pageConfig: {
        title: 'Статуси перевізників',
        icon: <TbTruckDelivery />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
